export default __webpack_public_path__ + "static/media/sl.2cd2ee6d.png";